module.exports = __webpack_public_path__ + "static/media/slide08.b2f97544.jpg";